/* =============================================================
   L'Odyssée du TCG — animations maison
   1) Poussière de particules flottantes, sur tout le site.
   2) Compteur qui monte pour la barre de stats.
   Purement décoratif : si quoi que ce soit échoue, le site reste
   parfaitement utilisable.
   ============================================================= */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

  /* -----------------------------------------------------------
     1. Poussière de particules flottantes, sur tout le site
     ----------------------------------------------------------- */
  function initAmbientParticles() {
    if (reduceMotion) return;
    if (document.querySelector('.odyssee-particles')) return;

    var container = document.createElement('div');
    container.className = 'odyssee-particles';
    container.setAttribute('aria-hidden', 'true');

    var COUNT = coarsePointer ? 10 : 20;
    for (var i = 0; i < COUNT; i++) {
      var particle = document.createElement('span');
      particle.className = 'odyssee-particle';
      if (Math.random() > 0.65) particle.className += ' odyssee-particle--accent';

      var size = (Math.random() * 5 + 2).toFixed(1) + 'px';
      particle.style.left = (Math.random() * 100).toFixed(1) + '%';
      particle.style.width = size;
      particle.style.height = size;
      particle.style.opacity = (Math.random() * 0.5 + 0.3).toFixed(2);
      particle.style.animationDuration = (Math.random() * 10 + 12).toFixed(1) + 's';
      particle.style.animationDelay = (Math.random() * -20).toFixed(1) + 's';

      container.appendChild(particle);
    }

    document.body.appendChild(container);
  }

  /* -----------------------------------------------------------
     2. Compteur qui monte pour la barre de stats
     ----------------------------------------------------------- */
  function animateCount(el) {
    if (el.dataset.odysseeCounted) return;
    el.dataset.odysseeCounted = '1';

    var target = parseFloat(el.getAttribute('data-count-to'));
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) return;

    if (reduceMotion) {
      el.textContent = target + suffix;
      return;
    }

    var isDecimal = target % 1 !== 0;
    var duration = 1600;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = target * eased;
      el.textContent = (isDecimal ? current.toFixed(1) : Math.round(current)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initStatsCounters(root) {
    var numbers = (root || document).querySelectorAll('.odyssee-stats__number');
    if (!numbers.length) return;

    if (!('IntersectionObserver' in window)) {
      numbers.forEach(animateCount);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) animateCount(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    numbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -----------------------------------------------------------
     3. Header transparent sur le hero, plein sitôt qu'on scrolle
     Uniquement sur l'accueil (voir odyssee-theme.css, tout est
     conditionné à .template-index) : le header flotte sur le hero
     tant qu'on est tout en haut, puis redevient un header normal.
     ----------------------------------------------------------- */
  function initTransparentHeader() {
    if (!document.body.classList.contains('template-index')) return;

    var threshold = 120;
    var ticking = false;

    function apply() {
      ticking = false;
      document.body.classList.toggle('odyssee-scrolled', window.scrollY > threshold);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -----------------------------------------------------------
     4. Infos utiles du hero — rotation en boucle continue
     Chaque zone (coin du hero) peut contenir plusieurs blocs
     « Info utile ». S'il y en a plus d'un, ils tournent : un
     message reste affiché le temps réglé dans l'éditeur, puis
     laisse la place au suivant, et ça reprend au premier une fois
     le dernier passé — indéfiniment.
     ----------------------------------------------------------- */
  function initHeroBadges() {
    var zones = document.querySelectorAll('[data-hero-zone]');
    if (!zones.length) return;

    zones.forEach(function (zone) {
      var badges = zone.querySelectorAll('[data-hero-badge]');
      if (badges.length < 2) return;
      if (reduceMotion) return; // une seule info statique suffit, pas de rotation

      var interval = parseInt(zone.dataset.interval, 10) || 4000;
      var current = 0;

      setInterval(function () {
        badges[current].classList.remove('is-active');
        current = (current + 1) % badges.length;
        badges[current].classList.add('is-active');
      }, interval);
    });
  }

  /* -----------------------------------------------------------
     Démarrage
     ----------------------------------------------------------- */
  function initAll(root) {
    initStatsCounters(root);
  }

  initTransparentHeader();
  initHeroBadges();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initAmbientParticles();
    });
  } else {
    initAll();
    initAmbientParticles();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initStatsCounters(event.target);
  });
})();
